import Swiper, { Navigation, FreeMode } from 'swiper';
import Component from '../Component';

class DesktopSlider extends Component {
  constructor(options) {
    super(options);
    this.next = this.root.querySelector('.swiper_next');
    this.prev = this.root.querySelector('.swiper_prev');
  }

  attachEventListeners() {
    const breakpoint = window.matchMedia('(min-width: 769px)');
    let shopSwiper;

    function debounce(func) {
      let timer;
      return (event) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 100, event);
      };
    }

    const enableShopSwiper = () => {
      shopSwiper = new Swiper(this.root, {
        modules: [Navigation, FreeMode],
        slidesPerView: 'auto',
        loop: true,
        grabCursor: true,
        spaceBetween: 15,
        freeMode: {
          enabled: true
        },
        navigation: {
          nextEl: this.next,
          prevEl: this.prev
        }
      });
    };

    if (breakpoint.matches) {
      enableShopSwiper();
    }

    window.addEventListener('resize', debounce(() => {
      if ((breakpoint.matches === true) && ((shopSwiper === undefined) || (shopSwiper.destroyed))) {
        enableShopSwiper();
      }
      if ((breakpoint.matches === false) && (shopSwiper !== undefined)) {
        shopSwiper.destroy(true, true);
      }
    }));
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default DesktopSlider;
